module.exports = __webpack_public_path__ + "static/media/Raleway-LightItalic.d817d3a1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Raleway-LightItalic.ttf
// module id = 3338
// module chunks = 51